module.exports = __webpack_public_path__ + "img/fan.6333b647.png";